<template>
    <main>
        <div class="content">
            <router-link class="item" v-for="i in companyList" :to="'/subsidiary/characteristic/' + i.id">
                <div @mouseenter="more = i.id" @mouseleave="more = null">
                    <img :src="i.companyPicture" alt="">
                    <div class="cover" :style="{ opacity: more == i.id ? '1' : '0' }"></div>
                    <div class="context">
                        <div class="mask">
                            <div class="more" :style="{ top: more == i.id ? '-3px' : '140px' }">
                                <div class="title">{{ i.companyName }}</div>
                                <div class="bor"></div>
                                <div class="address">地址：{{ i.companyAddress }}</div>
                                <div>邮编：{{ i.postcode }}</div>
                                <div>电话：{{ i.companyPhone }}</div>
                                <div>传真：{{ i.companyFax }}</div>
                            </div>
                        </div>

                        <div class="btn">点击查看更多>></div>
                    </div>
                </div>
            </router-link>
        </div>
    </main>
</template>
<style lang="less" scoped>
.content {
    width: 1200px;
    margin: 0 auto;
    background-color: #FFFFFF;
    min-height: 263px;
    position: relative;
    top: -40px;
    padding: 40px 15px;
    display: flex;
    // justify-content: center;
    flex-wrap: wrap;

    .item {
        width: 340px;
        height: 360px;
        position: relative;
        margin: 0 25px 52px;

        img {
            width: 340px;
            height: 360px;
            object-fit: cover;
        }

        .cover {
            width: 340px;
            height: 360px;
            position: absolute;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.6);
            transition: all 0.3s;
        }

        .context {
            width: 258px;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            text-align: left;

            .mask {
                position: absolute;
                top: 105px;
                left: 30px;
                height: 190px;
                width: 272px;
                overflow: hidden;

                .more {
                    position: absolute;
                    left: 0;
                    transition: all 0.3s;

                    .title {
                        font-size: 20px;
                        // height: 20px;
                        width: 272px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    .bor {
                        width: 171px;
                        height: 4px;
                        background-color: #FFFFFF;
                        margin-bottom: 18px;
                        margin-top: 12px;
                    }

                    .address {
                        // height: 45px;
                        width: 272px;
                        word-break: break-all;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                }
            }


            .btn {
                position: absolute;
                bottom: 34px;
                left: 30px;
            }
        }
    }

}


@media screen and (max-width: 1360px) {
    .content {
        width: 100% !important;
        padding: 15px;
        display: flex;
        flex-wrap: wrap;

        .item {
            margin: 10px !important;
            width: calc(50% - 20px);
            height: auto !important;
            overflow: hidden;
            display: block;
            position: relative;

            &>div {
                padding-top: 100%;
                position: relative;
                width: 100%;
                height: 0;
                left: 0;
                top: 0;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    position: absolute;
                    left: 0;
                    top: 0;

                }
            }

            .context {
                position: absolute;
                bottom: 0;
                left: 0;
                padding: 15px;
                width: 100%;

                .mask {
                    position: relative;
                    top: auto;
                    left: 0;
                    height: auto;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;

                    .more {
                        position: relative;
                        top: 0 !important;
                        .title {
                            overflow: visible;
                            white-space: normal;
                            width: 100%;
                            font-size: 17px;
                        }
                        .address {
                            display: none;

                            &~* {
                                display: none;

                            }
                        }
                    }
                }

                .btn {
                    position: static;
                }
            }
        }
    }
}
</style>

<script>
export default {
    data() {
        return {
            companyList: [],
            more: null
        }
    },
    methods: {
        getCompanyList() {
            let that = this;
            ajax.call(this, {
                url: "/company/list",
                data: {
                    pageNum: 1,
                    pageSize: 999,
                },
                s(res) {
                    if (res.data) {
                        that.companyList = res.data.map(v => {
                            return {
                                companyName: v.companyName,
                                companyPicture: v.companyPicture,
                                companyAddress: v.companyAddress,
                                companyFax: v.companyFax,
                                companyPhone: v.companyPhone,
                                postcode: v.postcode,
                                id: v.id
                            }
                        });
                    }


                }

            });
        },
    },
    mounted() {
        this.getCompanyList();
    },
    watch: {
        "$root.language"() {
            this.getCompanyList();
        },

    }
}
</script>